import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ItemUrls, Training } from '../app.urls';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ItemsUploadService {

  constructor(private http: HttpClient) { }

  DownloadFile(filePath: string, fileType: string): Observable<any> {
    let fileExtension = fileType;
    let input = filePath;

    return this.http.get(ItemUrls.DownloadFile + "?fileName=" + input, {

      responseType: 'blob',
      observe: 'response'
    })
      .pipe(
        map((res: any) => {
          return new Blob([res.body], { type: fileExtension });
        })
      );
  }

  public upload(formData) {
    const currentUserFromStorage = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    const accessTokenFromStoarge = currentUserFromStorage['accessToken'];

    const collectionId = sessionStorage.getItem('defaultcollectionid');
    const headers = { 'token': accessTokenFromStoarge };
    const httpOptions = { 'content-type': 'multipart/form-data; boundary=<calculated when request is sent>', 'headers': headers };
    return this.http.post(ItemUrls.upload + '?collectionId=' + collectionId, formData, httpOptions)
  }

  videoTutorial(assetGroup) {
    return this.http.get<any>(Training.tutorial + assetGroup);
  }
}
